import { render, staticRenderFns } from "./vehicle-page.vue?vue&type=template&id=a177b2ca&scoped=true&"
import script from "./vehicle-page.vue?vue&type=script&lang=js&"
export * from "./vehicle-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a177b2ca",
  null
  
)

export default component.exports